import YakFetch from './utils/yak_fetch';
import ServiceBase from './service_base';

export default class NotificationPreferencesService extends ServiceBase {
  static async fetch() {
    const endpoint = `${process.env.REACT_APP_SERVICE_ENDPOINT_BASE}/api/notification_preference`;
    const response = await YakFetch.fetch(endpoint, 'GET');
    await NotificationPreferencesService._abortIfUnsuccessful(response);
    const notificationPreferenceData = await response.json();
    return notificationPreferenceData;
  }

  static async update(preferences) {
    const endpoint = `${process.env.REACT_APP_SERVICE_ENDPOINT_BASE}/api/notification_preference`;
    const payload = {
      delivery_method: preferences.deliveryMethod,
      stop_everything: preferences.stopEverything,
      tack_archive: preferences.tackArchive,
      new_followers: preferences.newFollowers,
      words_from_people_followed: preferences.wordsFromPeopleFollowed,
      points: preferences.points,
      comments_from_people_followed: preferences.commentsFromPeopleFollowed,
      last_weeks_most_tacked: preferences.lastWeeksMostTacked,
      likes: preferences.likes,
      comment_mentions: preferences.commentMentions
    }
    const response = await YakFetch.fetch(endpoint, 'PUT', { body: payload });
    await NotificationPreferencesService._abortIfUnsuccessful(response);
    return true;
  }
}



// WEBPACK FOOTER //
// ./src/services/notification_preferences_service.js